import e from "./_freeGlobal.js";
var t = typeof self == "object" && self && self.Object === Object && self, o = e || t || Function("return this")();
const f = o;
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_root.js
// module id = 96
// module chunks = 41